<!-- Recovery Component HTML -->
<div class="auth-main">
    <div *ngIf="loading" class="auth-main__loader">
        <loader type="page" message="Загружаем ..."></loader>
    </div>
    <ng-container [ngSwitch]="page">
        <div class="auth-main__content" *ngIf="!loading">
            <img
                class="auth-main__mobile-logo"
                src="./assets/icons/auth/brand-logo.svg"
                alt="Логотип"
            />
            <div class="auth-main__title">
                <img
                    src="./assets/icons/auth/back.svg"
                    (click)="goBack()"
                    alt=""
                />
                <span>{{ AuthFormTitle }}</span>
            </div>
            <p class="auth-main__subtitle">Восстановление пароля</p>
            <app-progress-bar [progress]="currentStep"></app-progress-bar>

            <ng-template ngSwitchCase="mainData">
                <form
                    (ngSubmit)="onSubmitRecoveryData()"
                    [formGroup]="formRecoveryData"
                    class="form"
                    (keydown.enter)="focusNextInput($event)"
                >
                    <label>Фамилия *</label>
                    <div class="form__field">
                        <input
                            id="lastName"
                            type="text"
                            formControlName="lastName"
                            placeholder="Фамилия"
                            (input)="correctNameInput($event, 'lastName')"
                            #InputBlockLastName
                            [ngClass]="{
                                'invalid-input':
                                    formRecoveryData.get('lastName')?.touched &&
                                    formRecoveryData.get('lastName')?.invalid,
                            }"
                        />
                    </div>
                    <label>Имя *</label>
                    <div class="form__field">
                        <input
                            id="firstName"
                            type="text"
                            formControlName="firstName"
                            placeholder="Имя"
                            (input)="correctNameInput($event, 'firstName')"
                            #InputBlockfirstName
                            [ngClass]="{
                                'invalid-input':
                                    formRecoveryData.get('firstName')
                                        ?.touched &&
                                    formRecoveryData.get('firstName')?.invalid,
                            }"
                        />
                    </div>
                    <label>Отчество </label>
                    <div class="form__field">
                        <input
                            id="secondName"
                            type="text"
                            formControlName="secondName"
                            placeholder="Отчество"
                            (input)="correctNameInput($event, 'secondName')"
                            #InputBlockSecondName
                            [ngClass]="{
                                'invalid-input':
                                    formRecoveryData.get('secondName')
                                        ?.touched &&
                                    formRecoveryData.get('secondName')?.invalid,
                            }"
                        />
                    </div>
                    <label>Дата рождения *</label>
                    <div class="form__field">
                        <input
                            id="birthDate"
                            [type]="dateInputType"
                            formControlName="birthDate"
                            placeholder="01.01.1999"
                            #InputBlockBirthDate
                            [max]="maxBdate"
                            (focus)="onDateFocus()"
                            (blur)="onDateBlur()"
                            [ngClass]="{
                                'invalid-input':
                                    birthDateControl.invalid &&
                                    birthDateControl.touched,
                            }"
                        />
                    </div>
                    <div
                        *ngIf="
                            birthDateControl.invalid && birthDateControl.touched
                        "
                        class="warn-message"
                    >
                        <span *ngIf="birthDateControl.errors?.['required']"
                            >Дата рождения обязательна</span
                        >
                        <span
                            *ngIf="
                                birthDateControl.errors?.['invalidDateFormat']
                            "
                            >Неверный формат даты (ДД.ММ.ГГГГ)</span
                        >
                        <span *ngIf="birthDateControl.errors?.['invalidDate']"
                            >Некорректная дата</span
                        >
                        <span *ngIf="birthDateControl.errors?.['futureDate']"
                            >Указанная дата еще не наступила</span
                        >
                        <span *ngIf="birthDateControl.errors?.['dateTooOld']"
                            >Дата слишком устаревшая</span
                        >
                    </div>
                    <button
                        mat-raised-button
                        type="submit"
                        [disabled]="formRecoveryData.invalid"
                        class="form__submit"
                    >
                        <ng-container>Далее</ng-container>
                        <ng-container>
                            <div class="form__submit-loader"></div>
                        </ng-container>
                    </button>
                </form>
            </ng-template>
            <ng-template ngSwitchCase="mailPhone">
                <div
                    class="login-mode-toggle"
                    [ngClass]="{ 'tab-right': recoveryMode == 'SMS' }"
                    *ngIf="
                        recoveryTypeParam.includes('email') &&
                        recoveryTypeParam.includes('sms')
                    "
                >
                    <button
                        class="toggle-btn"
                        [ngClass]="{
                            'toggle-btn__active': recoveryMode == 'EMAIL',
                        }"
                        (click)="changeRecoveryMode('EMAIL')"
                    >
                        <span class="toggle-btn__text">Почта</span>
                    </button>
                    <button
                        class="toggle-btn"
                        [ngClass]="{
                            'toggle-btn__active': recoveryMode == 'SMS',
                        }"
                        (click)="changeRecoveryMode('SMS')"
                    >
                        <span class="toggle-btn__text">Номер телефона</span>
                    </button>
                </div>
                <form
                    (ngSubmit)="onSubmitDeliveryChannel()"
                    [formGroup]="formMail"
                    class="form"
                    *ngIf="recoveryMode === 'EMAIL'"
                    (keydown.enter)="focusNextInput($event)"
                >
                    <label>E-mail *</label>
                    <div class="form__field">
                        <input
                            id="email"
                            type="email"
                            formControlName="email"
                            placeholder="user@mail.ru"
                            (input)="removeSpaces($event)"
                            (keydown.space)="$event.preventDefault()"
                            #InputBlockEmail
                            [ngClass]="{
                                'invalid-input':
                                    formMail.get('email')?.touched &&
                                    formMail.get('email')?.invalid,
                            }"
                        />
                    </div>
                    <div class="captcha-block">
                        <div class="captcha-block__img">
                            <div
                                class="captcha__img"
                                [innerHTML]="captcha.svg | safe: 'html'"
                                *ngIf="!captchaLoad"
                            ></div>
                            <div *ngIf="captchaLoad" class="css-spinner"></div>

                            <button
                                class="captcha-block__refresh"
                                type="button"
                                (click)="refreshCaptcha()"
                            >
                                <mat-icon svgIcon="refresh"></mat-icon>
                            </button>
                        </div>
                        <div class="form__field">
                            <input
                                id="captcha"
                                type="string"
                                formControlName="captcha"
                                placeholder="Введите код с картинки"
                                maxlength="6"
                                (keydown.space)="$event.preventDefault()"
                                [ngClass]="{
                                    'invalid-input':
                                        formMail.get('captcha')?.touched &&
                                        formMail.get('captcha')?.invalid,
                                }"
                            />
                        </div>
                    </div>
                    <div class="error-message" *ngIf="errorMessage">
                        {{ errorMessage }}
                    </div>
                    <button
                        mat-raised-button
                        type="submit"
                        [disabled]="formMail.invalid || isTimerRunning()"
                        class="form__submit"
                    >
                        <div *ngIf="!isTimerRunning()">Восстановить</div>
                        <div>
                            <div class="form__submit-loader"></div>
                        </div>
                        <div *ngIf="isTimerRunning()">
                            Отправить повторно можно через
                            <strong>
                                {{ timerDisplay() }}
                            </strong>
                        </div>
                    </button>
                </form>
                <form
                    (ngSubmit)="onSubmitDeliveryChannel()"
                    [formGroup]="formPhone"
                    class="form"
                    *ngIf="recoveryMode === 'SMS'"
                    (keydown.enter)="focusNextInput($event)"
                >
                    <label>Номер телефона *</label>
                    <div class="form__field">
                        <input
                            id="phone"
                            type="tel"
                            formControlName="phone"
                            phoneMask
                            placeholder="+7 (___) ___-__-__"
                            [ngClass]="{
                                'invalid-input':
                                    formPhone.get('phone')?.touched &&
                                    formPhone.get('phone')?.invalid,
                            }"
                        />
                    </div>
                    <div class="captcha-block">
                        <div class="captcha-block__img">
                            <div
                                class="captcha__img"
                                [innerHTML]="captcha.svg | safe: 'html'"
                                *ngIf="!captchaLoad"
                            ></div>
                            <div *ngIf="captchaLoad" class="css-spinner"></div>

                            <button
                                class="captcha-block__refresh"
                                type="button"
                                (click)="refreshCaptcha()"
                            >
                                <mat-icon svgIcon="refresh"></mat-icon>
                            </button>
                        </div>
                        <div class="form__field">
                            <input
                                id="captcha"
                                type="string"
                                formControlName="captcha"
                                placeholder="Введите код с картинки"
                                maxlength="6"
                                (keydown.space)="$event.preventDefault()"
                                [ngClass]="{
                                    'invalid-input':
                                        formPhone.get('captcha')?.touched &&
                                        formPhone.get('captcha')?.invalid,
                                }"
                            />
                        </div>
                    </div>
                    <div class="error-message" *ngIf="errorMessage">
                        {{ errorMessage }}
                    </div>
                    <button
                        mat-raised-button
                        type="submit"
                        [disabled]="formPhone.invalid || isTimerRunning()"
                        class="form__submit"
                    >
                        <ng-container>Восстановить</ng-container>
                        <ng-container>
                            <div class="form__submit-loader"></div>
                        </ng-container>
                    </button>
                    <span class="auth-code__timerRec" *ngIf="isTimerRunning()">
                        Отправить повторно можно через
                        <strong>{{ timerDisplay() }}</strong>
                    </span>
                </form>
            </ng-template>

            <div class="content-bottom">
                <div class="auth-main__register-hint" *ngIf="AccessReg">
                    Впервые в личном кабинете?
                </div>
                <div
                    class="go-to-button"
                    (click)="goToRegistration()"
                    *ngIf="AccessReg"
                >
                    Регистрация
                </div>
            </div>
        </div>
    </ng-container>
    <div class="auth-main__img" *ngIf="!loading">
        <img class="img-logo" src="./assets/icons/auth/brand-logo.svg" alt="" />
        <img
            class="img-doctor"
            src="./assets/icons/auth/recovery-illustration.svg"
            alt=""
        />
    </div>
</div>

<!-- <div
    [@showOpacityAnimation]="animState"
    (@showOpacityAnimation.done)="whenAnimate($event)"
    class="recovery__wrapper"
>
    <div
        *ngIf="
            newPasswordForm.controls['newPW2'].hasError('passwordMismatch') &&
            (newPasswordForm.controls['newPW2'].dirty ||
                newPasswordForm.controls['newPW2'].touched)
        "
        class="error-message"
    >
        Пароли не совпадают.
    </div>

    <form
        class="reg-form"
        [formGroup]="newPasswordForm"
        *ngIf="!isTokenRecovery"
    >
        <div class="loading-group">
            <div *ngIf="loading" class="loading">
                <loader type="page"> </loader>
            </div>
            <mat-form-field class="w-100">
                <input
                    type="{{ newPassHidden ? 'text' : 'password' }}"
                    matInput
                    formControlName="newPW"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
                <mat-label>Новый пароль</mat-label>
                <span
                    matSuffix
                    (click)="newPassHiddenHandler()"
                    class="hidden__button"
                >
                    <mat-icon
                        [svgIcon]="
                            newPassHidden ? 'password-visible' : 'password-hidden'
                        "
                    ></mat-icon>
                </span>
            </mat-form-field>
            <mat-form-field class="w-100">
                <input
                    type="{{ newPassHiddenConfirm ? 'text' : 'password' }}"
                    matInput
                    formControlName="newPW2"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
                <mat-label>Повтор нового пароля</mat-label>
                <span
                    matSuffix
                    (click)="newPassHiddenHandlerConfirm()"
                    class="hidden__button"
                >
                    <mat-icon
                        [svgIcon]="
                            newPassHiddenConfirm
                                ? 'password-visible'
                                : 'password-hidden'
                        "
                    ></mat-icon>
                </span>
            </mat-form-field>

            <button
                class="w-100 btn btn-lg cls-btn cls-btn-reg"
                type="submit"
                [disabled]="loading || newPasswordForm.invalid"
                (click)="goRecoveryNewPW()"
            >
                Сменить
            </button>

            <div class="cls-txt-center cls-footer1">Есть аккаунт?</div>
            <div
                class="cls-txt-center cls-footer2"
                (click)="goAuth()"
                *ngIf="AccessReg"
                placeholder="Регистрация"
            >
                Войти
            </div>
        </div>
    </form>

    <form class="reg-form" [formGroup]="recoveryForm" *ngIf="isTokenRecovery">
        <div class="loading-group">
            <div *ngIf="loading" class="loading">
                <loader type="page"> </loader>
            </div>

            <mat-form-field class="w-100">
                <input
                    [type]="'text'"
                    matInput
                    formControlName="lastName"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
                <mat-label>Фамилия</mat-label>
            </mat-form-field>

            <mat-form-field class="w-100">
                <input
                    [type]="'text'"
                    matInput
                    formControlName="firstName"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
                <mat-label>Имя</mat-label>
            </mat-form-field>

            <mat-form-field class="w-100">
                <input
                    [type]="'text'"
                    matInput
                    formControlName="secondName"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="false"
                />
                <mat-label>Отчество</mat-label>
            </mat-form-field>

            <mat-form-field class="w-100">
                <input
                    type="date"
                    matInput
                    formControlName="birthDate"
                    required="true"
                    [max]="maxDate"
                    [readonly]="loading"
                    (keypress)="formatDate($event)"
                />
                <mat-label>Дата рождения</mat-label>
            </mat-form-field>

            <mat-form-field class="w-100">
                <mat-label>Почта</mat-label>
                <input
                    [type]="'text'"
                    matInput
                    formControlName="email"
                    placeholder="guest@mail.ru"
                    [readonly]="loading"
                    (keydown.space)="$event.preventDefault()"
                    required="true"
                />
            </mat-form-field>

            <div class="phone__captcha captcha">
                <div class="captcha__left">
                    <mat-form-field class="input">
                        <input
                            type="string"
                            id="regcaptha"
                            matInput
                            placeholder="Введите код с картинки"
                            maxlength="10"
                            formControlName="captcha"
                            [readonly]="loading"
                            (keydown.space)="$event.preventDefault()"
                            required
                        />
                    </mat-form-field>
                </div>
                <div class="captcha__right">
                    <div
                        *ngIf="captcha; else captchaLoader"
                        class="captcha-content"
                    >
                        <div
                            class="captcha__img"
                            [innerHTML]="captcha.svg | safe : 'html'"
                        ></div>

                        <button
                            class="captcha__refresh"
                            type="button"
                            (click)="refreshCaptcha()"
                        >
                            <mat-icon svgIcon="refresh"></mat-icon>
                        </button>
                    </div>

                    <ng-template #captchaLoader>
                        <div class="loader-wrapper">
                            <span class="loader"></span>
                        </div>
                    </ng-template>
                </div>
            </div>

            <button
                class="w-100 btn btn-lg cls-btn cls-btn-reg"
                type="submit"
                [disabled]="loading || !recoveryForm.valid"
                (click)="goRecovery()"
            >
                Восстановить
            </button>

            <div class="cls-txt-center cls-footer1">Есть аккаунт?</div>
            <div
                class="cls-txt-center cls-footer2"
                (click)="goAuth()"
                placeholder="Регистрация"
            >
                Войти
            </div>
        </div>
    </form>
</div>
-->
